export default "__VITE_ASSET__DnBwY13Z__"